import React from 'react'
import styles from './styles.module.css'
import Img from '../../../Img' // task #67: canonical image component
import Text from '../../../Text'
import Cta from '../../../CtaV2'
import SimpleBlockContent from '../../../SimpleBlockContent'

// task #67: inlined from the now-deleted utils/images (pure string helper, not
// image resolution).
const buildImageAlt = (prefix, index) => `${prefix}-${index}`

function PedalsHero({ title, images, text, ctaV2 }) {
  return (
    <div className={styles.wrapper}>
      <div className={styles.contentWrapper}>
        <div className={styles.images}>
          {
            images.map((image, index) => (
              <div
                className={styles.imageWrapper}
                style={{ transform: `rotate(${index === 1 ? 0 : index === 0 ? -15 : 15}deg)` }}
                key={buildImageAlt(title, index)}
              >
                {/* task #67: descriptor via <Img> */}
                <Img
                  image={image}
                  alt={buildImageAlt(title, index)}
                  objectFit="contain"
                />
              </div>

            ))
          }
        </div>
        <div className={styles.textAndCtas}>
          <div className={styles.textWrapper}>
            <Text type="h1-hero" primary className={styles.heroTitle}>{title}</Text>
          </div>
          <div className={styles.ctaWrapper}>
            <Cta
              {...ctaV2}
              fullWidth
            />
            <SimpleBlockContent blocks={text}/>
          </div>
        </div>
      </div>
    </div>
  )
}

export default PedalsHero
